export enum TypeFiltre {
	EQUIPE,
	GROUPE_DE_TRAVAIL
}
